import React, { FC } from "react";
import { Field } from "react-final-form";
import { Grid } from "@material-ui/core";
import BootstrapInput from "../../../../../components/BootstrapInput";
import Autocomplete from "../../../../../components/Autocomplete";
import FieldsGroupLabel from "../common/FieldsGroupLabel";
import { ICourseComponentProps } from "../../../types";
import { getDurationUnits } from "../../../../../constants";

const durationUnitWithoutDays = getDurationUnits("Course")
  .slice(1)
  .slice(0, -1);

const CourseDuration: FC<ICourseComponentProps> = ({ fieldsGroupName }) => {
  return (
    <div>
      <FieldsGroupLabel
        label="Course Duration"
        className="fields-group-label"
      />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <Field
            required
            fullWidth
            label="Duration Period"
            options={durationUnitWithoutDays}
            placeholder="Please Select"
            name={`${fieldsGroupName}.durationUnit`}
            component={Autocomplete}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Field
            required
            fullWidth
            type="text"
            label="Duration"
            placeholder={"Only numbers"}
            name={`${fieldsGroupName}.durationAmount`}
            component={BootstrapInput}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default React.memo(CourseDuration);
